import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../shared/DefaultBadge.css';
import './WeightLots.css';
import { formatWeightLotId } from './WeightLotDropdown.js';

const formatScoreDatetime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return '—';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = String(d.getFullYear()).slice(-2);
  const HH = String(d.getHours()).padStart(2, '0');
  const MM = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yy} ${HH}:${MM}`;
};

const WeightLotCard = ({ row, defaultLotId, latestScoreMap, getProtocolName }) => {
  const { t }    = useTranslation();
  const navigate = useNavigate();
  const isDefault = row.lot_id === defaultLotId;
  const score = latestScoreMap?.[row.lot_id];
  const protocolName = getProtocolName ? getProtocolName(row.protocol_id) : null;

  return (
    <div className="wl-card" onClick={() => navigate(`/weight/lots/${row.lot_id}`)}>
      <div className="wl-card-main">
        <div className="wl-card-code">{formatWeightLotId(row.lot_id, t('weight_lot_prefix'))}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {isDefault && <span className="default-badge">★ {t('default')}</span>}
          <div className="wl-card-chevron">›</div>
        </div>
        {row.name && <div className="wl-card-name">{row.name}</div>}
        {(score || (protocolName && protocolName !== '—')) && (
          <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
            {protocolName && protocolName !== '—' && protocolName}
            {protocolName && protocolName !== '—' && score && ' · '}
            {score && (
              <>
                {t('score_value')}:{' '}
                <span style={{
                  fontWeight: 600,
                  color: score.score > 0 ? '#2d7a2d' : score.score < 0 ? '#c0392b' : '#888',
                }}>
                  {score.score > 0 ? `+${score.score}` : String(score.score)}
                </span>
                {' · '}{formatScoreDatetime(score.scored_at)}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const WeightLotCardList = ({ data, defaultLotId, latestScoreMap, getProtocolName }) => {
  return (
    <div className="wl-card-list">
      {data && data.map(row => (
        <WeightLotCard
          key={row._id}
          row={row}
          defaultLotId={defaultLotId}
          latestScoreMap={latestScoreMap}
          getProtocolName={getProtocolName}
        />
      ))}
      {(!data || data.length === 0) && (
        <div className="wl-card-empty">—</div>
      )}
    </div>
  );
};

export default WeightLotCardList;
